// removed by extract-text-webpack-plugin
module.exports = {"counter":"_14IkK","counterMemberArea":"_1LP5U","viewCount":"_1Im9V","commentCount":"_3zSyF"};


//////////////////
// WEBPACK FOOTER
// ./app/components/post-stats/post-stats.scss
// module id = 1107
// module chunks = 0 3 5